<form role="form" [formGroup]="form" *ngIf="form">
  <div class="row">
    <div class="col-md-4"></div>
    <div class="col-md-4">
      <div>
        <mat-card class="card">
          <mat-card-content>
            <div class="form-group row  mb-2">
              <label for="customer" class="col-4 col-form-label-sm fw-bold">LOC: </label>
              <div class="col-8 ">
                <select name="locCode" id="locCode" class="custom-select custom-select-sm form-control form-select-sm"
                  (change)="resetSearchParameters()" formControlName="locCode">
                  <option *ngFor="let item of locList" value="{{item.value}}">{{item.text}}</option>
                </select>
              </div>
            </div>
            <div class="form-group row  mb-2">
              <label for="customer" class="col-4 col-form-label-sm fw-bold">Date Range: </label>
              <div class="col-8 ">
                <select name="mobilePlanPeriod" id="mobilePlanPeriod"
                  class="custom-select custom-select-sm form-control form-select-sm" formControlName="mobilePlanPeriod"
                  (change)="selectPeriodDates($event.target,'change')">
                <option *ngFor="let period of planPeriods" [value]="period.value">
                    {{period.text}}
                  </option>
                </select>
              </div>
            </div>

            <div class="form-group row  mb-2 d-flex">
              <div class="col-6" *ngIf="showCustomDatePicker">
                <label class="col-12 col-form-label-sm fw-bold">Start Date:</label>
                <div class="col-12">
                  <input type="date" name="periodStartDate" id="periodStartDate" formControlName="customPeriodStartDate"
                    (change)="customDates($event.target, 'start')" class="borderless-input" />
                </div>
              </div>

              <div class="col-6" *ngIf="showCustomDatePicker">
                <label class="col-12 col-form-label-sm fw-bold">End Date:</label>
                <div class="col-12">
                  <input type="date" name="periodEndDate" id="periodEndDate" formControlName="customPeriodEndDate"
                    (change)="customDates($event.target,'end')" class="borderless-input" />
                </div>
              </div>
            </div>

            <div class="form-group row  mb-2">
              <label for="customer" class="col-4 col-form-label-sm fw-bold">Plan By:</label>
              <div class="col-8">
                <select name="locationType" id="locationType"
                  class="form-control custom-select custom-select-sm form-select-sm"
                  (change)="changeLocationType($event.target)" formControlName="locationType">
                  <option value="0">Origin</option>
                  <option value="1">Destination</option>
                </select>
              </div>
            </div>

            <div class="form-group row mb-2 align-items-center">
              <label for="customer" class="col-4 col-form-label-sm fw-bold">Search For:</label>
              <div class="col-6">
                <div class="d-flex ">
                  <span class="form-check-label me-4" for="flexSwitchCheckDefault">{{ searchedForIsDispatch ?
                    'Dispatches' : 'Schedules' }}</span>
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault"
                      [(ngModel)]="searchedForIsDispatch" [ngModelOptions]="{standalone: true}"
                      (change)="toggleChanged($event)" style="transform: scale(1.8);">
                  </div>
                </div>
              </div>
            </div>

            <ng-container *ngIf="showAdditionalFilter">
              <div class="form-group row  mb-2">
                <label for="customer" class="col-4 col-form-label-sm fw-bold">Customer:</label>
                <div class="col-8 ">
                  <select class="form-control custom-select custom-select-sm form-select-sm" name="customerId"
                    id="customerId" formControlName="customerId" (change)="loadDropdowns($event.target,'customer')">
                    <option value="0">Please Select Customer</option>
                    <option *ngFor="let x of customers; trackBy: trackByNumberValue" [value]="x.id">{{x.text}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group row  mb-2">
                <label for="origin" class="col-4 col-form-label-sm fw-bold">Origin:</label>
                <div class="col-8 ">
                  <select class="form-control custom-select custom-select-sm form-select-sm" name="locationId"
                    id="locationId" formControlName="originId" (change)="loadDropdowns($event.target,'origin')">
                    <option value="0">Please Select Origin </option>
                    <option *ngFor="let x of origins; trackBy: trackByNumberValue" [value]="x.id">{{x.text}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group row mb-2">
                <label for="destination" class="col-4 col-form-label-sm fw-bold">Destination:</label>
                <div class="col-8 ">
                  <select class="form-control custom-select custom-select-sm form-select-sm" name="locationId"
                    id="locationId" formControlName="destinationId"
                    (change)="loadDropdowns($event.target,'destination')">
                    <option value="0">Please Select Destination</option>
                    <option *ngFor="let x of destinations; trackBy: trackByNumberValue" [value]="x.id">{{x.text}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group row  mb-2">
                <label for="trucker" class="col-4 col-form-label-sm fw-bold">Trucker:</label>
                <div class="col-8">
                  <select class="form-control custom-select custom-select-sm form-select-sm" name="truckerCode"
                    id="truckerCode" formControlName="truckerId" (change)="loadDropdowns($event.target,'trucker')">
                    <option value="0">Please Select Trucker</option>
                    <option *ngFor="let x of truckers; trackBy: trackByNumberValue" [value]="x.id">{{x.text}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group row  mb-2">
                <label for="commodity" class="col-4 col-form-label-sm fw-bold">Commodity:</label>
                <div class="col-8 ">
                  <select class="form-control custom-select custom-select-sm form-select-sm" name="commodityCode"
                    id="commodityCode" formControlName="commodityCode"
                    (change)="loadDropdowns($event.target,'commodity')">
                    <option value="">Please Select Commodity</option>
                    <option *ngFor="let x of commodities; trackBy: trackByStringValue" [value]="x.value">{{x.text}}
                    </option>
                  </select>
                </div>
              </div>
            </ng-container>


            <div class="d-flex align-items-center">
              <div class="d-flex justify-content-center w-100">
                <button type="button" class="btn btn-sm btn-primary me-2" style="width: 30px;" (click)="search()">
                  <i class="fa-solid fa-magnifying-glass"></i>
                </button>

                <button type="button" class="btn btn-sm btn-secondary me-2" style="width: 30px;"
                  (click)="showAdditionalFilter = !showAdditionalFilter"
                  [innerHTML]="!showAdditionalFilter ? '<i class=\'fa-solid fa-filter\'></i>' : '<i class=\'fa-solid fa-filter-circle-xmark\'></i>'">
                </button>

                <button *ngIf="showAdditionalFilter" type="button" class="btn btn-sm btn-light me-2"
                  style="width: 30px;" (click)="resetFormFields('changeAll')">
                  <i class="fa-solid fa-arrows-rotate"></i>
                </button>
              </div>

              <div class="ms-auto">
                <i class="fa-solid fa-circle-info fa-2xl" style="margin-left: 10px;" data-bs-toggle="modal"
                  data-bs-target="#infoModal"></i>
              </div>
            </div>

          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div class="col-md-4"></div>
  </div>
</form>



<div class="row mb-0">
  <div class="mb-1 d-flex align-items-center">
    {{ searchedForIsDispatch ? 'Dispatches:' : 'Schedules:' }} 
    {{ searchedForIsDispatch ? dispatchList.length : (showDestination ? destinationsResult.length : originsResult.length) }}
    <div class="text-danger ms-2" *ngIf="message">{{ message }}</div>
  </div>
</div>


<div class="col-12 col-md-8 mx-auto" *ngIf="!searchedForIsDispatch else dispatches">
  <div class="table-container overflow-auto" style="margin-top: 10px;">
    <div style="display: inline-block; white-space: nowrap;">

      <div class="d-flex align-items-center" *ngIf="showOrigin" id="originHeader">
        <div class="p-1 text-center col-form-label-sm" style="min-width: 25px;"></div>
        <div class="p-1 text-center col-form-label-sm" style="min-width: 50px; font-weight: 600;">Comm</div>
        <div class="p-1 text-center col-form-label-sm" style="min-width: 200px;">Customer</div>
        <div class="p-1 text-center col-form-label-sm" style="min-width: 140px;">Dest City</div>
        <div class="p-1 text-center col-form-label-sm" style="min-width: 75px;">F/D</div>
        <div class="p-1 text-center col-form-label-sm" style="min-width: 75px;">Loads</div>
        <div class="p-1 text-center col-form-label-sm" style="min-width: 75px;">Disp</div>
        <div class="p-1 text-center col-form-label-sm" style="min-width: 75px;">Bal</div>
        <div class="p-1 text-center col-form-label-sm" style="min-width: 75px;">Un-Assign</div>
        <div class="p-1 text-center col-form-label-sm" style="min-width: 75px;">Un-Conf</div>
        <div class="p-1 text-center col-form-label-sm" style="min-width: 75px;">Conf</div>
      </div>

      <div *ngIf="showOrigin" id="originSection">
        <ng-container *ngIf="originsResult && originsResult.length > 0 ;else other_content">
          <div class="row">
            <div class="col-md-12">
              <ng-container *ngFor="let data of originsResult; let i = index">
                <mat-card class="card" [ngClass]="{'odd-bg': i % 2 !== 0, 'even-bg': i % 2 === 0}">

                  <div class="d-flex align-items-center" (click)="openDispatch(data.scheduleId)">
                    <div class="p-1 text-center" style="min-width: 25px;"><i class="fa-solid fa-list-ul"
                        *ngIf="data.dispatchesCount > 0" style="color: #5194c8;" aria-hidden="true"></i></div>
                    <div class="p-1 text-center" style="min-width: 50px;">{{ data.commodityCode }}</div>
                    <div class="p-1 text-center" style="min-width: 200px;">{{ data.customerName }}</div>
                    <div class="p-1 text-center" style="min-width: 140px;">{{ data.locationCity }}</div>
                    <div class="p-1 text-center" style="min-width: 75px;">{{ data.deliveryTerm }}</div>
                    <div class="p-1 text-center" style="min-width: 75px;">
                      <input type="number" [(ngModel)]="data.loads" [ngModelOptions]="{standalone: true}"
                        class="form-control form-control-sm custom-input-bg text-center" min="0"
                        style="width: 100%; text-align: center;" (keydown)="restrictNegativeValue($event)"
                        (click)="$event.stopPropagation()" (blur)="updateScheduleLoad(data, $event)" />
                    </div>
                    <div class="p-1 text-center" style="min-width: 75px;">{{ data.dispatchedLoads }}</div>
                    <div class="p-1 text-center" style="min-width: 75px;">{{ data.balanceLoads }}</div>
                    <div class="p-1 text-center" style="min-width: 75px;">{{ data.unassignedLoads }}</div>
                    <div class="p-1 text-center" style="min-width: 75px;">{{ data.unconfirmedLoads }}</div>
                    <div class="p-1 text-center" style="min-width: 75px;">{{ data.confirmedLoads }}</div>
                  </div>

                </mat-card>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="d-flex align-items-center" *ngIf="showDestination" id="destinationHeader">
        <div class="p-1 text-center col-form-label-sm" style="min-width: 25px;"></div>
        <div class="p-1 text-center col-form-label-sm" style="min-width: 50px;">Comm</div>
        <div class="p-1 text-center col-form-label-sm" style="min-width: 200px;">Customer</div>
        <div class="p-1 text-center col-form-label-sm" style="min-width: 140px;">Origin City</div>
        <div class="p-1 text-center col-form-label-sm" style="min-width: 75px;">F/D</div>
        <div class="p-1 text-center col-form-label-sm" style="min-width: 75px;">Loads</div>
        <div class="p-1 text-center col-form-label-sm" style="min-width: 75px;">Disp</div>
        <div class="p-1 text-center col-form-label-sm" style="min-width: 75px;">Bal</div>
        <div class="p-1 text-center col-form-label-sm" style="min-width: 75px;">Un-Assign</div>
        <div class="p-1 text-center col-form-label-sm" style="min-width: 75px;">Un-Conf</div>
        <div class="p-1 text-center col-form-label-sm" style="min-width: 75px;">Conf</div>
      </div>

      <div *ngIf="showDestination" id="destinationSection">
        <ng-container *ngIf="destinationsResult && destinationsResult.length > 0 ;else other_content">
          <div class="row">
            <div class="col-12">
              <ng-container *ngFor="let data of destinationsResult; let i = index">
                <mat-card class="card" [ngClass]="{'odd-bg': i % 2 !== 0, 'even-bg': i % 2 === 0}">

                  <div class="d-flex align-items-center" (click)="openDispatch(data.scheduleId)">
                    <div class="p-1 text-center" style="min-width: 25px;"><i class="fa-solid fa-list-ul"
                        *ngIf="data.dispatchesCount > 0" style="color: #5194c8;" aria-hidden="true"></i></div>
                    <div class="p-1 text-center" style="min-width: 50px;">{{ data.commodityCode }} </div>
                    <div class="p-1 text-center" style="min-width: 200px;">{{ data.customerName }}</div>
                    <div class="p-1 text-center" style="min-width: 140px;">{{ data.locationCity }}</div>
                    <div class="p-1 text-center" style="min-width: 75px;">{{ data.deliveryTerm }}</div>
                    <div class="p-1 text-center" style="min-width: 75px;">
                      <input type="number" [(ngModel)]="data.loads" [ngModelOptions]="{standalone: true}"
                        class="form-control form-control-sm custom-input-bg text-center" min="0"
                        style="width: 100%; text-align: center;" (keydown)="restrictNegativeValue($event)"
                        (click)="$event.stopPropagation()" (blur)="updateScheduleLoad(data, $event)" />
                    </div>
                    <div class="p-1 text-center" style="min-width: 75px;">{{ data.dispatchedLoads }}</div>
                    <div class="p-1 text-center" style="min-width: 75px;">{{ data.balanceLoads }}</div>
                    <div class="p-1 text-center" style="min-width: 75px;">{{ data.unassignedLoads }}</div>
                    <div class="p-1 text-center" style="min-width: 75px;">{{ data.unconfirmedLoads }}</div>
                    <div class="p-1 text-center" style="min-width: 75px;">{{ data.confirmedLoads }}</div>
                  </div>

                </mat-card>
              </ng-container>
            </div>

          </div>
        </ng-container>

      </div>
    </div>

    <div class="fixedButtonRight" data-bs-toggle="modal" data-bs-target="#scheduleModal"
      (click)="manualScheduleClick()">
      <div class="roundedFixedRightBtn"><i class="fa-solid fa-circle-plus"></i></div>
    </div>

    <ng-template #other_content>
      <div class="col-md-12 d-flex align-items-center" style="height: 100%;">
        <mat-card clas="card" style="width: 100%; max-width: 600px;">
          <mat-card-content>No schedules found for your search criteria</mat-card-content>
        </mat-card>
      </div>
    </ng-template>
  </div>
</div>

<ng-template #dispatches>
  <div class="col-12 col-md-8 mx-auto">
    <div class="table-container overflow-auto"
      style="margin-top: 10px; max-height: 50vh;margin-left:-2px;display: flex;">
      <div style="height: 100%;">
        <div class="sticky-header">
          <div class="d-flex align-items-center">
            <div class="p-1 text-center col-form-label-sm sticky-column"
            [ngStyle]="{'margin-left': hasOpenedIcon ? '8px' : '-14px'}"
              style="font-weight: 600;color:#fff;height: 20px;">
              {{hasOpenedIcon ?
              'DetailedActionToOpenContr' : ''}}
            </div>
            <div class="p-1 text-center col-form-label-sm dispatch-origin-header" style="min-width: 210px;">Origin
            </div>
            <div class="p-1 text-center col-form-label-sm" style="min-width: 140px;">Trucker</div>
            <div class="p-1 text-center col-form-label-sm" style="min-width: 75px;">Comm</div>
            <div class="p-1 text-center col-form-label-sm" style="min-width: 230px;">Destination</div>
            <div class="p-1 text-center col-form-label-sm" style="min-width: 75px;">Loads</div>
            <div class="p-1 text-center col-form-label-sm" style="min-width: 100px;">Rate</div>
            <div class="p-1 text-center col-form-label-sm" style="min-width: 130px;">Email Status</div>
            <div class="p-1 text-center col-form-label-sm" style="min-width: 130px;">Roger Status</div>
            <div class="p-1 text-center col-form-label-sm" style="min-width: 150px;">Entered By</div>
          </div>
        </div>

        <div class="row" id="SchedulesSection" style="max-height: 100%">
          <div class="col-12 col-md-8 mx-auto">
            <ng-container *ngIf="dispatchList && dispatchList.length > 0; else other_content">
              <ng-container *ngFor="let data of dispatchList; let i = index">
                <mat-card class="card odd-bg" [ngClass]="{'italic': data.showMoreIcons}">
                  <div class="d-flex align-items-center position-relative">

                    <div class="p-1 text-center d-flex fixed-icons-container sticky-column">
                      <div class="text-primary mb-1" role="button" aria-label="Right Arrow" (click)="toggleIcons(data)">
                        <i class="fa-solid fa-circle-chevron-right" style="color: #5194c8; margin-top: 10px;"></i>
                      </div>

                      <div *ngIf="hasOpenedIcon" class="d-flex align-items-center fixed-icons"
                        [ngClass]="{'disabled': !data.showMoreIcons && !isInitialLoad, 'enable': isShowMoreIconsEnabledInAnyDispatch()}">
                        <div class="text-primary ms-2" role="button" aria-label="Edit Dispatch">
                          <a href="#" class="edit-btn" data-bs-toggle="modal" attr.data-bs-target="#{{dispatchFormId}}"
                            (click)="editDispatch(data.scheduleId, data.dispatchId)">
                            <i class="fa-solid fa-pen-to-square fa-lg"></i>
                          </a>
                        </div>
                        <div class="text-primary mx-2" role="button" aria-label="Alert Trucker">
                          <a href="#" class="grid-icon-btn send-btn dropdown-item" data-bs-toggle="modal"
                            attr.data-bs-target="#{{alertTruckerFilterModalIdSc}}"
                            (click)="sendAlertTruckerDispatch(data)">
                            <i class="fa-solid fa-bell fa-lg"></i>
                          </a>
                        </div>
                        <div class="text-primary" role="button"
                          [ngClass]="{'disabled': !(data.truckerId > 0), 'enable': data.truckerId > 0}"
                          aria-label="Send Dispatch">
                          <a href="#" class="grid-icon-btn send-btn dropdown-item" data-bs-toggle="modal"
                            attr.data-bs-target="#{{confirmDispatchFormId}}" (click)="sendDispatch(data.dispatchId)">
                            <i class="fa-solid fa-envelope fa-lg"></i>
                          </a>
                        </div>
                        <div class="text-primary " role="button" aria-label="Apply Loadnumber">
                          <a class="ms-2" href="#" tabindex="-1" data-bs-toggle="modal"
                            attr.data-bs-target="#{{loadBankApplyFormIdSc}}" title="find load number"
                            (click)="openLoadBank(0,data)">
                            <i class="fa-solid fa-upload fa-lg text-primary mx-1"></i> </a>
                        </div>
                        <div class="text-primary " role="button" aria-label="Apply Unloadnumber">
                          <a class="ms-2" href="#" tabindex="-1" data-bs-toggle="modal"
                            attr.data-bs-target="#{{loadBankApplyFormIdSc}}" title="find unload number"
                            (click)="openLoadBank(1,data)">
                            <i class="fa-solid fa-download fa-lg text-primary mx-1"></i>
                          </a>
                        </div>
                        <div class="text-primary mx-2" role="button" aria-label="Delete">
                          <a href="#" class="grid-icon-btn delete-btn dropdown-item" data-bs-toggle="modal"
                            attr.data-bs-target="#{{deleteFormId}}"
                            (click)="deleteDispatch(data.dispatchId, data.truckerName)">
                            <i class="fa-solid fa-trash fa-lg"></i>
                          </a>
                        </div>
                      </div>
                    </div>


                    <div class="scrollable-content"
                      [ngClass]="{'disabled': !data.showMoreIcons && !isInitialLoad, 'enable': isShowMoreIconsEnabledInAnyDispatch()}">
                      <div class="p-1 text-center"
                        style="min-width: 210px; max-width: 210px; white-space: normal; overflow-wrap: break-word;">
                        <div>{{data.originName}}, </div>
                        <div>{{data.originCity}}</div>
                      </div>
                      <div class="p-1 text-center"
                        style="min-width: 140px; max-width: 140px; white-space: normal; overflow-wrap: break-word;"
                        [ngClass]="{'text-danger': data.roundId > 0 }">
                        {{data.truckerName}}
                      </div>
                      <div class="p-1 text-center" style="min-width: 75px;">{{ data.commodityCode }}</div>
                      <div class="p-1 text-center"
                        style="min-width: 230px; max-width: 230px; white-space: normal; overflow-wrap: break-word;">
                        <div>{{data.destinationName}},</div>
                        <div>{{data.destinationCity}}</div>
                      </div>
                      <div class="p-1 text-center" style="min-width: 75px;">
                        <button #loadsModalBtn type="button" class="link-style" data-bs-toggle="modal"
                          data-bs-target="#loadsModal" [ngClass]="{'disable-load-count': data.showMoreIcons }"
                          [disabled]="!isShowMoreIconsEnabledInAnyDispatch()"
                          (click)="setSelectedLoadItem(globalDispatchId ?? data.dispatchId)">
                          {{ data.numberOfLoads }}
                        </button>
                      </div>
                      <div class="p-1 text-center" style="min-width: 100px;">{{data.rate}}</div>
                      <div class="p-1 text-center" style="min-width: 130px;">{{data.emailStatus}}</div>
                      <div class="p-1 text-center" style="min-width: 130px;">{{data.rogerStatus}}</div>
                      <div class="p-1 text-center" style="min-width: 150px;">{{data.enteredBy}}</div>
                    </div>
                  </div>
                </mat-card>
              </ng-container>
            </ng-container>
          </div>

          <ng-template #other_content>
            <div class="col-md-12 d-flex align-items-center" style="height: 100%;">
              <mat-card class="card" style="width: 100%; max-width: 600px;">
                <mat-card-content>No dispatches found for your search criteria</mat-card-content>
              </mat-card>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<div class="modal fade" id="infoModal" tabindex="-1" role="dialog" aria-labelledby="infoModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="infoModalLabel">Search Criteria</h5>
        <button type="button" #closeButton class="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <table class="table table-bordered">
          <tbody>
            <tr *ngIf="storedDataFromLS?.locCodeValue">
              <td>LOC:</td>
              <td>{{storedDataFromLS?.locCodeValue}}</td>
            </tr>
            <tr *ngIf="storedDataFromLS?.selectedPeriodRange">
              <td>Date:</td>
              <td>{{storedDataFromLS?.selectedPeriodRange == 'WeekPrevious' ? 'Previous Week'
                : (storedDataFromLS?.selectedPeriodRange == 'WeekCurrent' ? 'Current Week'
                : (storedDataFromLS?.selectedPeriodRange == 'MonthPrevious' ? 'Previous Month'
                : (storedDataFromLS?.selectedPeriodRange == 'MonthCurrent' ? 'Current Month'
                : (storedDataFromLS?.selectedPeriodRange == 'MonthNext' ? 'Next Month'
                : (storedDataFromLS?.selectedPeriodRange == 'WeekNext' ? 'Next Week' : 'Custom')))))}}
              </td>
            </tr>
            <tr *ngIf="storedDataFromLS?.periodStartDate">
              <td>Start Date:</td>
              <td>{{storedDataFromLS?.periodStartDate}}</td>
            </tr>
            <tr *ngIf="storedDataFromLS?.periodEndDate">
              <td>End Date:</td>
              <td>{{storedDataFromLS?.periodEndDate}}</td>
            </tr>
            <tr>
              <td>Plan By:</td>
              <td>{{storedDataFromLS?.locationType == 0 ? 'Origin' : 'Destination'}}</td>
            </tr>
            <tr *ngIf="storedDataFromLS?.customerName && storedDataFromLS?.customerName != 'Please Select Customer'">
              <td>Customer:</td>
              <td>{{storedDataFromLS?.customerName}}</td>
            </tr>
            <tr *ngIf="storedDataFromLS?.originName  && storedDataFromLS?.originName != 'Please Select Origin ' ">
              <td>Origin:</td>
              <td>{{storedDataFromLS?.originName}}</td>
            </tr>
            <tr
              *ngIf="storedDataFromLS?.destinationName && storedDataFromLS?.destinationName != 'Please Select Destination'">
              <td>Destination:</td>
              <td>{{storedDataFromLS?.destinationName}}</td>
            </tr>
            <tr *ngIf="storedDataFromLS?.truckerName && storedDataFromLS?.truckerName != 'Please Select Trucker'">
              <td>Trucker:</td>
              <td>{{storedDataFromLS?.truckerName}}</td>
            </tr>
            <tr *ngIf="storedDataFromLS?.commodity && storedDataFromLS?.commodity != 'Please Select Commodity'">
              <td>Commodity:</td>
              <td>{{storedDataFromLS?.commodity}}</td>
            </tr>
            <tr *ngIf="storedDataFromLS?.selectedSearchFor && storedDataFromLS?.selectedSearchFor != '0'">
              <td>Search for:</td>
              <td>{{storedDataFromLS?.selectedSearchFor}}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</div>


<app-load-list (loadListEmit)="loadLoads($event)" (closePoupEmit)="globalDispatchId = null;"
  (deleteComplete)="reloadDispatchCount($event)" [loads]="loadsData"></app-load-list>

<load-bank-apply [parameters]="loadBankApplyParameters" [loadBankApplyFormId]="loadBankApplyFormIdSc"
  (loadBankApplyCompleteForDispatchMobile)="loadBankApplyComplete($event)" [isMobile]="true"></load-bank-apply>

<schedule-form [scheduleDefaults]="scheduleForm" (saveComplete)="scheduleComplete($event)"></schedule-form>

<delete-confirm #deleteConfirmChildComponent [deleteItemParameters]="deleteItemParams" [deleteFormId]="deleteFormId"
  (confirmEmitter)="deleteItem($event, deleteItemParams)"></delete-confirm>


<confirm-dispatch [dispatchId]="sendDispatchId" [refresh]="sendDispatchRefresh"
  [confirmDispatchFormId]="confirmDispatchFormId" (sendComplete)="sendComplete($event)"></confirm-dispatch>


<app-alert-truckers-filter [alertParameters]="alertTruckerForm"
  [dispatchId]="sendAlertTruckerDispatchId"></app-alert-truckers-filter>
<!-- (saveComplete)="alertTruckerFilterComplete($event)" -->

<dispatch-form [dispatchParameters]="dispatchForm" [dispatchFormId]="dispatchFormId"
  (saveComplete)="dispatchSaveComplete($event)"></dispatch-form>